var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColourPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_184_4210",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_184_4210",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAACCklEQVR4nO3cv2oUYRiF8fOuRUDXW1B7Ea/BPynWVryCBKwDCpYpraJEFIXoDQSxFIzmGiy0D16CZEUXZl4LtxJ2Nju78x13fH71fpwkT2bY6pMAAAAAAAAAAAAAAH0VpQf37uW1KrUd0q2Urkx/iJM69TFqHTx8F1/6vP+3YgH2R7nx67yeKHRf0mDGx2pJL8ehnd3DmPRpf5YiAfZHuTEZ6n2mbpzxyPE4NFrVH8G932TWf8JK/bygpwv88pJ0c5ja68t+k86fgOk797MWj11VqeuP3sbXdd6fp/MnoEptt9w5Nwhtrfv+PCVeQbfbHozQZg/2G5UIcKn1ydTlHuw3KhFguMTZiz3Yb1TkWxBmI4AZAcwIYEYAMwKYEcCMAGYEMCOAGQHMCGBGADMCmBHAjABmBDAjgBkBzAhgRgAzApgRwIwAZgQwI4AZAcwIYEYAMwKYEcCMAGYEMCOAGQHMCGBGADMCmBHArESA0yXOfu/BfqMSAb61PhlLnP139ht1HiBTR60P1/qw7vvzdB4gah1IqlocrSrpzbrvz9N5gOkdbK8WPRfSi1Xc1ePen6fIt6BxaEfS8Vk/n9Kn09CDvuw3KRJg9zAm49AopOdqfh1UIT37Ebqzyvva3PtNil9b+fhuXh2EtiK0qfxzbaRCJ5k6qlOvu37s3fsAAAAAAAAAAAAAgP/HbxP0xHBJ/JerAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColourPause);
export default __webpack_public_path__ + "static/media/colourPause.6fe8bea4eb81e8fc66894375ef7dc6c6.svg";
export { ForwardRef as ReactComponent };